import { ProductName } from 'Constants/products.constants';
import { BaseHomeInsuranceDetails } from '../insurance.types';

export type HomeBuyerInsuranceProductTypes =
  | ProductName.HOME_BUYER_INTEREST
  | ProductName.HOME_BUYER_MOVE
  | ProductName.HOME_BUYER_HOUSE
  | ProductName.HOME_BUYER_HOUSE_CONTENTS;

export interface HomeBuyerDetails extends BaseHomeInsuranceDetails {
  insuranceProduct: HomeBuyerInsuranceProductTypes;
  homeBuyerFacade: HomeBuyerFacade;
}

export enum HomeBuyerFacade {
  HOUSE = 'HOUSE',
  ATTACHED_HOUSE = 'ATTACHED_HOUSE',
  CONDOMINIUM = 'CONDOMINIUM',
  COOPERATIVE_APARTMENT = 'COOPERATIVE_APARTMENT',
  STOCK_APARTMENT = 'STOCK_APARTMENT',
  RECREATIONAL_RESIDENCE = 'RECREATIONAL_RESIDENCE',
  LOTS = 'LOTS',
}

export enum HomeBuyerProductCategory {
  HOUSE = 'HOUSE',
  CABIN = 'CABIN',
}
